import React from 'react'
import { Modal, Button, Text, Flex, tokens } from 'src/componentv2'

export interface ConfirmModalProps {
    open: boolean
    title?: string
    message: React.ReactNode
    confirmLabel?: string
    onConfirm: () => void
    onClose: () => void
    loading?: boolean
}

export const ConfirmModal: React.FC<ConfirmModalProps> = ({
                                                              open, title = 'Are you sure?', message, confirmLabel = 'Delete', onConfirm, onClose, loading = false,
                                                          }) => (
    <Modal open={open} onClose={onClose} title={title} maxWidth="40rem">
        <Text fontSize="1.4" color={tokens.textMuted}>
            {message}
        </Text>
        <Flex justify="flex-end" gap="1.2" topMargin="2">
            <Button variant="outline" onClick={onClose}>Cancel</Button>
            <Button variant="primary" onClick={onConfirm} disabled={loading}>
                {loading ? 'Deleting...' : confirmLabel}
            </Button>
        </Flex>
    </Modal>
)

export default ConfirmModal